import type { AudioQualityIssue } from './audio-quality';
import type { InitialDataCopy } from './initial-data-copy';

// Type-only imports: tools/tests/initial-data.test.mjs loads this file on its own.
export type { InitialDataCopy };

/** Replaces `{name}` placeholders in a translated string. */
export function fill(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in values ? String(values[key]) : match,
  );
}

/** Spec 006: the translated, measurable reason a recording was refused. */
export function qualityIssueLabel(copy: InitialDataCopy, issue: AudioQualityIssue): string {
  const labels: Record<AudioQualityIssue, string> = {
    CLIPPED: copy.qualityClipped,
    MOSTLY_SILENT: copy.qualityMostlySilent,
    TOO_QUIET: copy.qualityTooQuiet,
    NOISY: copy.qualityNoisy,
  };
  return labels[issue];
}
